import withProgress from 'core/components/progress/withProgress'
import Dropdown from 'core/elements/dropdown'
import GlobalDropdownWithSearch from 'core/elements/dropdown/GlobalDropdownWithSearch'
import useListAction from 'core/hooks/useListAction'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { listUserTenants } from './new-actions'
import { userTenantsSelector } from './selectors'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

interface TenantPicklistProps {
  disabled?: boolean
  name?: string
  label?: string
  includeNoneOption?: boolean
  includeAllOption?: boolean
  compact?: boolean
  onChange: (value: string) => void
  value: string
  width?: number
  align?: 'left' | 'right'
  [key: string]: any
}

export default function TenantPicklist({
  disabled = false,
  name = 'tenant',
  label = 'Tenant',
  includeNoneOption = false,
  includeAllOption = false,
  compact = true,
  onChange,
  value,
  width = 180,
  align = 'left',
  ...rest
}: TenantPicklistProps) {
  const { loading } = useListAction(listUserTenants)
  const tenants = useSelector(userTenantsSelector)

  const items = useMemo(() => {
    const tenantOptions = tenants.map((tenant) => ({
      label: tenant.name,
      value: tenant.id,
    }))

    const result = []
    if (includeAllOption) {
      result.push({ label: 'All Tenants', value: '' })
    }
    if (includeNoneOption) {
      result.push({ label: '-- None --', value: '' })
    }
    return [...result, ...tenantOptions]
  }, [tenants, includeNoneOption, includeAllOption])

  return compact ? (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading}
      items={items}
    />
  ) : (
    <GlobalDropdownWithSearch
      label={label}
      items={items}
      loading={loading}
      onChange={(item) => onChange(item.value)}
      value={value}
      showLabelOnTop
      align={align}
      disabled={disabled}
      width={width}
    />
  )
}
